import React from 'react';
import { makeStyles } from "@mui/styles";
import { motion } from "framer-motion"

const useStyles = makeStyles({
  root: {},
  bkg: {
    fill: 'rgba(0, 0, 0, 0.05)'
  },
  bar: {
    fill: 'rgba(77, 110, 227, 1)'
  },
  dividerLine: {
    strokeWidth: '0.1',
    stroke: 'rgb(255, 255, 255, 0.5)',
    // strokeDasharray: '0.5'
  },
  text: {
    fontSize: '0.1em',
    letterSpacing: '0.04em'
  },
  similar: {
    fill: 'rgba(183, 255, 80, 0.1)'
  },
  dissimilar: {
    fill: 'rgba(255, 143, 80, 0.1)'
  },
  mid: {
    fill: 'rgba(0, 0, 0, 0.05)'
  }
});

// For indicating 1-100 values
// can cut off w/ min & max props
const Bar = (props) => {
  const { min, max } = props

  const height = 5

  const lines = [ 10, 15, 20, 30, 40, 50, 55, 60 ]

  // default props?

  const classes = useStyles();

  return(
    <svg viewBox={`${min} 0 ${max-min} ${height}`} xmlns="http://www.w3.org/2000/svg" className={classes.root}>

      {/* BKG Rect */}
      <rect width="100" height={height} className={classes.bkg} />

      <rect width="20" height={height} className={classes.dissimilar} />
      <rect width="50" x='50' height={height} className={classes.similar} />
      <rect width="30" x='20' height={height} className={classes.mid} />

      {lines.map((dist, index) => (
        <g key={index}>
          {/* <line x1={dist} y1="0" x2={dist} y2={height} className={classes.dividerLine} /> */}
          <text x={dist} y="4" textAnchor="middle" className={classes.text}>{dist}</text>
        </g>
      ))}

      <text x='35' y="2" textAnchor="middle" className={classes.text}>Midrange</text>
      <text x='51' y="2" textAnchor="start" className={classes.text}>Similar</text>
      <text x='19' y="2" textAnchor="end" className={classes.text}>Dissimilar</text>

    </svg>
  )
}

export default Bar;
